export enum UploadSource {
  DRIVER = 'DRIVER',
  COURT = 'COURT',
}
